var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoMobile = function SvgLogoMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 34,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4B5563",
    d: "m28.168 24.57.01.013-7.44 7.6a.3.3 0 0 1-.037.033 5.728 5.728 0 0 1-8.168-.012l4.078-4.165 3.399-3.472-3.387-3.46-4.077-4.163a5.68 5.68 0 0 1 8.153-.002l.002.002 3.387 3.46z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#10AD27",
    d: "m16.625 5.832-.002.002-.01-.01-3.399 3.471-4.08 4.166-3.397 3.471.01.01 3.398 3.474 4.079 4.163-4.079 4.166-7.486-7.647c-2.214-2.31-2.212-6.013.01-8.32L8.522 5.78a5.68 5.68 0 0 1 8.102.052"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B5563",
    d: "M31.83 20.827a5 5 0 0 1-.253.28L24.1 13.472l-4.077-4.166-3.4-3.47.002-.001a5.68 5.68 0 0 0-8.102-.052l.622-.638 3.364-3.44q.02-.02.037-.034a5.73 5.73 0 0 1 8.137-.02l.008.008q.023.022.047.046l3.364 3.436v.002l7.463 7.623v.002c2.151 2.219 2.237 5.736.265 8.06"
  })));
};
export default SvgLogoMobile;